<script>
import {
  required
} from "vuelidate/lib/validators";

export default {
    name: 'MacModal',
    data() {
        return {
            macAddress: '',
            formattedMacAddress: '',
            results:[],
            submitted: false,
        };
    },  
    validations: {
        form: {  
            cause: { required },
        },
    },
    methods: {
        formatMacAddress() {
            let formatted = this.macAddress.replace(/[^a-fA-F0-9]/g, '').toUpperCase(); 
            formatted = formatted.match(/.{1,2}/g).join(':'); 
            
            this.macAddress = formatted;
            
            if(formatted?.length > 4){
                this.$http.post('/members/mac-query', { mac:this.macAddress})
                        .then(response => this.results = response.data)
            }
            
        },
        temizle(){
            this.macAddress = ''
            this.results = []
        },
        kontrol(data) {
           var altiCizili = '';
            var index = 0;

            // Giriş kelimesi ile hedef kelimeyi karşılaştır
            for (var i = 0; i < data.length; i++) {

                if (this.macAddress[i] === data[index]) {
                    
                     // Eşleşen harf ise normal şekilde ekle
                    altiCizili += data[i];
                  
                    index++;
                } else {
                     // Eşleşmeyen harf ise altını çiz
                    altiCizili += '<u style="text-decoration-color: #00ff08;  text-decoration-thickness: 3px;">' + data[i] + '</u>';
                }
            }
            return altiCizili;
        },
        close(){
            this.$parent.$bvModal.hide('mac_modal')
        }
    },
};
</script>

<template>
<b-modal id="mac_modal"  hide-header hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row d-flex flex-wrap">
            <label class="col-sm-5 col-form-label col-form-label" for="cause">M.A.C</label>
            <div class="col">
                <div class="input-group mb-3">
                    <input 
                        type="text" 
                        v-model="macAddress"  
                        @input="formatMacAddress" 
                        class="form-control" 
                        placeholder="M.A.C">
                    <div class="input-group-append">
                        <b-button 
                            @click="temizle"
                            variant="light" 
                            class="ms-1"
                            >Temizle
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="results.length > 0">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <td>İsim Soyisim</td>
                            <td>K Adi</td>
                            <td>Telefon</td>
                            <td>M.A.C.</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(result,i) in results" :key="i">
                            <th>{{ result.fullname }}</th>
                            <th>{{ result.username }}</th>
                            <th>{{ result.phonenumber }}</th>
                            <th v-html="kontrol(result.mac)"></th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</b-modal>
</template>